import { Box, FormControlLabel, Switch } from "@mui/material";
import { InfoIconTooltip } from "components/InfoIconTooltip";
import { ReviewMode } from "generated-graphql/graphql";
import React from "react";

import { PriorityOrderInfoTooltip } from "./Tooltips";

interface PriorityOrderSwitchProps {
  value: ReviewMode;
  onChange: (reviewMode: ReviewMode) => void;
  disabled?: boolean;
  label?: string;
  labelSize?: string | number;
}

export function PriorityOrderSwitch({
  value,
  onChange,
  disabled = false,
  label = "Send reviews in priority order",
  labelSize = "14px",
}: PriorityOrderSwitchProps) {
  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            checked={value === ReviewMode.Sequential}
            onChange={(e) =>
              onChange(e.target.checked ? ReviewMode.Sequential : ReviewMode.Parallel)
            }
            color="primary"
            disabled={disabled}
          />
        }
        label={label}
        labelPlacement="end"
        sx={{
          mr: 0,
          "& .MuiFormControlLabel-label": {
            fontSize: labelSize,
          },
        }}
      />
      <InfoIconTooltip tooltip={<PriorityOrderInfoTooltip />} iconButtonSx={{ ml: 1 }} />
    </Box>
  );
}
